import { flow, types, Instance } from 'mobx-state-tree';
import { LogModel, ILogModel } from './models/devices.model';
import { AxiosResponse } from 'axios';
import axios from 'server';

const { model, array, string } = types;

export const DevicesTableStore = model('DevicesTableStore', {
  logs: array(LogModel),
  filter: string,
})
  .views((self) => ({
    get devicesView(): ILogModel[] {
      return self.logs.map((log) => ({ ...log }));
    },
  }))
  .actions((self) => ({
    normalizeLogs({ data }: AxiosResponse): { logs: ILogModel[]; meta: any; total?: number } {
      if (!data || !data.data) return { logs: [], meta: {} };

      const rawData = Array.isArray(data.data?.data)
        ? data.data.data
        : Array.isArray(data.data)
        ? data.data
        : Array.isArray(data)
        ? data
        : [];

      // Transform the data to match the model structure
      const logsData = rawData.map((item: any) => ({
        ...item,
        // Ensure all required fields are present
        id: item.id,
        client_id: item.client_id || null,
        user_id: item.user_id,
        login_time: item.login_time,
        ip_address: item.ip_address,
        city: item.city || null,
        region: item.region || null,
        country: item.country || null,
        device: item.device || null,
        os: item.os || null,
        browser: item.browser || null,
        created_at: item.created_at,
        updated_at: item.updated_at,
        user: item.user || null,
        // Legacy fields
        additionalData: null,
        eventType: null,
        clientId: item.client_id || null,
      }));

      const total = data.data?.total || data.total;
      self.logs.replace(logsData);
      return { logs: self.logs, meta: data.meta || {}, total };
    },
    setFilter(filter: string) {
      self.filter = filter;
    },
    clearStore(): ILogModel[] {
      self.logs.clear();
      return self.logs;
    },
  }))
  .actions((self) => ({
    getDevicesInfo: flow(function* (page = 1, limit = 10) {
      try {
        const response = yield axios.get(`logs/devices`, {
          params: {
            page,
            limit,
          },
        });
        return self.normalizeLogs(response);
      } catch (error: any) {
        console.error('Failed to fetch logs:', error);
        throw error;
      }
    }),
    getEndUserDevicesInfo: flow(function* (page = 1, limit = 10) {
      try {
        const response = yield axios.get(`user/logs/devices`, {
          params: {
            page,
            limit,
          },
        });
        return self.normalizeLogs(response);
      } catch (error: any) {
        console.error('Failed to fetch logs:', error);
        throw error;
      }
    }),
  }));

export type IDevicesTableStore = Instance<typeof DevicesTableStore>;
